import { Page } from "@react-pdf/renderer";

const PdfPage = ({
  children,
  pageNumber,
  submittedBy,
  submittedDate,
  style,
  padding = 30,
  ...props
}) => (
  <Page
    size="A4"
    style={{
      flexDirection: "column",
      backgroundColor: "#ffffff",
      padding,
      fontSize: 10,
      ...style,
    }}
    {...props}
  >
    {children}
  </Page>
);

export default PdfPage;
